import API from '@/api'
/**
 * Contact class
 */
export default class {
  constructor (data) {
    this.id = ~~data.id
    this.name = `${data.first_name} ${data.last_name}`
    this.firstName = data.first_name
    this.lastName = data.last_name
    this.company = data.company
    this.jobTitle = data.job_title
    this.addressType = data.address_type
    this.street = data.street
    this.city = data.city
    this.state = data.state
    this.postalCode = data.postal_code
    this.country = data.country
    this.phoneNumbers = data.phone_numbers || [{ phone_number: '', label: '' }]
    this.emails = data.emails || []
    this.useAsCallerid = (data.use_as_callerid === true || data.use_as_callerid === false) ? data.use_as_callerid : true
    this.hasImage = data.has_image
    this.image = null
    this.imageUrl = ~~data.id === 0 ? null : API.baseURLPath(`contacts/${~~data.id}/image`) + `?date=${Date.now()}`
    this.tags = data.tags
    this.personalTags = data.personal_tags
    this.tagsAsArray = data.tags !== '' ? data.tags?.split(' ') : []
    this.personalTagsAsArray = data.personal_tags ? data.personal_tags.split(' ') : []
    this.isPersonal = (data.is_personal === true || data.is_personal === false) ? data.is_personal : true
  }

  phoneNumbersAsString () {
    if (Array.isArray(this.phoneNumbers)) {
      return this.phoneNumbers.map(obj => obj.phone_number).join(' ')
    }
  }

  emailsAsString () {
    if (Array.isArray(this.emails)) {
      return this.emails.map(obj => obj.email).join(' ')
    }
  }

  address () {
    return encodeURIComponent(`${this.street} ${this.city} ${this.state} ${this.country}`)
  }
}
